"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    msgSelectArchetypeVersion: {
        id: 'newAugur.stepTwo.select_a_archetype_version',
        defaultMessage: 'Select an Archetype Version',
    },
    msgNoVersionSelected: {
        id: 'newAugur.stepOne.no_version_selected',
        defaultMessage: 'No archetype version selected',
    },
});
//# sourceMappingURL=archetypes.js.map